import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { Tournament } from 'Src/models/tournament';

interface GeneratedReport {
  reportId: string | number;
  reportType: string;
}

export const downloadHighLevelTournamentReport = ({ reportId, reportType }: GeneratedReport): void => {
  if (typeof reportId === 'undefined' || !reportType) {
    throw new Error('The report file was not returned by the server.');
  }

  const downloadFrame = document.createElement('iframe');
  downloadFrame.setAttribute('aria-hidden', 'true');
  downloadFrame.style.display = 'none';
  downloadFrame.src = `${(window as any).apiBase}/public/report/${reportId}/reportType/${reportType}`;
  document.body.appendChild(downloadFrame);

  // The report endpoint responds with Content-Disposition: attachment. Keeping the
  // request in a hidden frame avoids an asynchronously opened popup being blocked.
  window.setTimeout(() => downloadFrame.remove(), 60_000);
};

export function HighLevelTournamentReportErrorModal({
  isOpen,
  message,
  onClose
}: {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}) {
  return (
    <SimpleModal
      isOpen={isOpen}
      title="Report could not be generated"
      onCloseClick={onClose}
      onBackdropClick={onClose}
      showFooter={false}
      isBodyBold={false}
      customClass="highLevelTournamentReportErrorModal"
      dialogStyle={{ maxWidth: 480 }}
    >
      <div className="highLevelTournamentReportErrorModal__content">
        <div className="highLevelTournamentReportErrorModal__message">
          {message || 'The report could not be generated. Please try again.'}
        </div>
        <div className="highLevelTournamentReportErrorModal__actions">
          <button type="button" className="eDsButton eDsButton--primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </SimpleModal>
  );
}

export const getHighLevelTournamentReportModalProps = (
  title: string,
  tournament: Tournament,
  onCloseClick: () => void
) => ({
  title: (
    <div className="unionTournamentReportTitle">
      <span className="unionTournamentReportTitle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
        </svg>
      </span>
      <span>
        <strong>{title}</strong>
        <small>{tournament?.name || 'High-level tournament report'}</small>
      </span>
    </div>
  ),
  onCloseClick,
  showFooter: false,
  isBodyBold: false,
  customClass: 'unionTournamentReportParametersModal highLevelTournamentReportParametersModal',
  bodyClassName:
    'unionTournamentReportParametersModal__body highLevelTournamentReportParametersModal__body',
  dialogStyle: { maxWidth: 680 }
});
